import { CopyText } from "./JoachimChatGPT";

const PACKAGES = {
  joachim: {
    title: "Kunst am Standort präsentieren",
    description: "Ein Fototermin im Lokal mit ausgestellten Werken und Raumansichten. Optional kommen Künstlerporträts dazu. Bearbeitete Bilder können nach vereinbarter Freigabe für die Standortseite und Social Media verwendet werden.",
    questions: [
      "Was soll im Grundpaket enthalten sein, und wie viele fertige Bilder lieferst du?",
      "Wie viel Zeit brauchst du für Abstimmung, Anfahrt, Shooting, Auswahl und Bearbeitung?",
      "Welche eigene Vergütung brauchst du dafür? Welche Fahrt- oder Fremdkosten kommen dazu?",
      "Welche Nutzungsrechte sind enthalten: Website, Social Media, Werbung und Nutzung durch Künstler und Lokal?",
      "Welchen Einsatzradius, welche Vorlaufzeit und welche Lieferfrist kannst du anbieten?",
      "Was kostet extra, etwa Künstlerporträts, weitere Bilder oder zusätzliche Bearbeitungsrunden?"
    ]
  },
  george: {
    title: "Kunst trifft Vintage",
    description: "Eine abgestimmte Ecke im Lokal mit Kunst, ausgewählten Möbeln und Dekoration. Planung, Lieferung und Aufbau werden passend zum Raum vereinbart. Welche Stücke und Arbeiten dazugehören, legst du mit René vorab fest.",
    questions: [
      "Wie könnte eine konkrete Beispielecke aussehen? Welche Möbel, Dekoration und Arbeiten wären enthalten?",
      "Werden die Stücke verkauft oder vermietet? Wem gehören sie, und wie lange stehen sie im Lokal?",
      "Wie viel Zeit brauchst du für Abstimmung, Suche, Herrichten, Planung, Transport und Aufbau?",
      "Welche Material-, Einkaufs-, Fahrt- und Helferkosten entstehen?",
      "Welche eigene Vergütung brauchst du zusätzlich zu diesen Kosten?",
      "Wer übernimmt spätere Abholung oder Rückbau, und was kostet das?",
      "Welche Wünsche wären Zusatzarbeiten und müssten vorab gesondert angeboten werden?"
    ]
  }
};

export default function PartnerPackageDraft({ person }) {
  const p = PACKAGES[person];
  if (!p) return null;
  const worksheet = [
    p.title, "Interner Paketentwurf – Preis noch offen",
    "Mein konkreter Leistungsumfang:",
    ...p.questions.map((q, i) => (i + 1) + ". " + q + "\nMeine Antwort:"),
    "Meine Arbeitszeit insgesamt:",
    "Meine eigene Vergütung:",
    "Material / Einkauf / Fremdkosten:",
    "Anfahrt / Transport:",
    "Abholung / Rückbau, falls erforderlich:",
    "Offene Punkte:",
    "Kunstfund-Gebühr: mit René noch gemeinsam festlegen.",
    "Endpreis für den Standort: erst nach gemeinsamer Kalkulation festlegen."
  ].join("\n\n");
  return <section className="bg-white border-2 border-[#0047FF] p-6 sm:p-8" data-testid={person + "-package-draft"}>
    <p className="text-xs uppercase tracking-wider font-bold text-[#0047FF]">Interner Entwurf · Gemeinsam ergänzen</p>
    <h2 className="text-2xl sm:text-3xl font-black mt-3">Dein mögliches Paket: {p.title}</h2>
    <p className="mt-4 leading-relaxed">{p.description}</p>
    <p className="mt-4 font-bold">Preis: noch offen – gemeinsam kalkulieren</p>
    <p className="mt-3 text-sm">Das ist ein Vorschlag zum Weiterdenken. Ergänze oder ändere ihn so, dass du die Leistung tatsächlich anbieten kannst. Das Paket ist noch nicht öffentlich buchbar.</p>
    <h3 className="text-xl font-black mt-6">Damit wir zu einem realistischen Preis kommen</h3>
    <ol className="list-decimal pl-5 mt-4 space-y-3 text-sm">{p.questions.map(q => <li key={q}>{q}</li>)}</ol>
    <div className="bg-[#EBF0FF] p-4 mt-6 text-sm space-y-3">
      <p><strong>So entsteht der Preis:</strong> Deine eigene Vergütung + Material und Fremdkosten + Anfahrt und Logistik + gegebenenfalls Abholung + gemeinsam vereinbarte Kunstfund-Gebühr. Umsatzsteuer wird je nach Rechnungsstellung gesondert geklärt.</p>
      <p>Nenne René zuerst, was du für deine Leistung und die Kosten brauchst. Die Kunstfund-Gebühr und den Gesamtpreis für den Standort legt ihr danach gemeinsam fest. Noch offene Beträge bleiben offen; sie werden nicht als null gerechnet.</p>
      <p>Zusatzarbeiten werden vor Ausführung freigegeben. Transport, Aufbau und spätere Wechsel sind nur enthalten, wenn ihr sie ausdrücklich einplant und bezahlt.</p>
    </div>
    <details className="mt-6"><summary className="font-bold cursor-pointer">Antwortvorlage kopieren und ausfüllen</summary><div className="mt-4"><CopyText text={worksheet} label="Kalkulationsfragen kopieren" /></div></details>
    <p className="mt-4 text-sm">{person === "joachim" ? "Deine Antworten kannst du im bestehenden ChatGPT-Bereich auf dieser Seite an René übergeben oder ihm direkt schicken." : "Kopiere die Vorlage, ergänze deine Antworten und schicke sie René über euren bestehenden Kontakt."}</p>
  </section>;
}
